import { memo, useContext, useEffect, useMemo, useState } from "react"
import { FlowSheetCard } from "./FlowSheetCard"
import { AddSheetCard } from "./AddSheetCard"
import styles from './index.module.less'
import outerStyles from '../index.module.less'
import { useRequest } from "ahooks"
import { getFlowFiles } from "@/services/project/flowsheets"
import { projectContext } from "@/layouts/MainLayout"
import TemplatePanel from "../TemplatePane"
import classNames from "classnames"
import { Input, Space } from "antd"
import { OPermission } from "@/components/OPermission/OPermission"
import { ROLE_DRAFTER } from "@/components/OPermission/PlanPermission"
const { Search } = Input;

export const FlowSheets = memo(() => {
  const { projectId } = useContext(projectContext)
  const { data: files = [], refresh } = useRequest(() => getFlowFiles(projectId))
  const [search, setSearch] = useState('')

  const onSearch = (text: string = '') => {
    setSearch(text)
  }

  const filteredFiles = useMemo(() => {
    if (!search) {
      return files;
    }
    const searchText = search.toLowerCase()

    return files.filter((item) => {
      return item.name?.toLowerCase().includes(searchText) || item.description?.toLowerCase().includes(searchText)
    })
  }, [search, files])

  return <div className={outerStyles.cardContainer}>
    <div className={classNames('flex-space-btw', outerStyles.cardHeader)}>
      <Space>
        <div>Flowsheets</div>
        <div><Search placeholder="Filter the flows" allowClear onInput={(e: any) => onSearch(e.target.value)} style={{ width: 200 }} onClear={onSearch} /></div>
      </Space>
      
      <div><OPermission permissions={ROLE_DRAFTER}><TemplatePanel /></OPermission></div>
    </div>
    <div className={outerStyles.cardBody}>
      {filteredFiles.map(item => {
        return <FlowSheetCard key={item.id} flowsheet={item} pId={projectId} refresh={refresh} />
      })}
      
      <OPermission permissions={ROLE_DRAFTER}><AddSheetCard refresh={refresh} /></OPermission>
    </div>
  </div>
})